import { forwardRef } from "react";
import { cn } from "../../utils/cn";
import { INPUT_CLS } from "../chrome/fieldChrome";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", ...props }, ref) => (
    <input ref={ref} type={type} className={cn(INPUT_CLS, className)} {...props} />
  ),
);
Input.displayName = "Input";
